import { useConfig } from "_utils/useConfig";
import React, { useEffect, useState } from "react";

import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { RestoreOriginalUriFunction } from "@okta/okta-react/bundles/types/OktaContext";

import { oktaRedirectUrlLegacy } from "./routes";

const restoreOriginalUri: RestoreOriginalUriFunction = async (oktaAuth: OktaAuth, originalUri: string) => {
  const redirectUrl = toRelativeUrl(originalUri || "/", window.location.origin);
  window.location.replace(redirectUrl);
};

export const AuthProvider = ({ children }: Props) => {
  const { OKTA_CLIENT_ID, OKTA_ISSUER } = useConfig();
  const [oktaAuth, setOktaAuth] = useState<OktaAuth>(undefined);

  useEffect(() => {
    if (OKTA_CLIENT_ID && OKTA_ISSUER) {
      const newOktaAuth = new OktaAuth({
        issuer: OKTA_ISSUER,
        clientId: OKTA_CLIENT_ID,
        redirectUri: window.location.origin + oktaRedirectUrlLegacy,
        scopes: ["openid", "profile", "email"],
      });
      setOktaAuth(newOktaAuth);
    } else {
      setOktaAuth(undefined);
    }
  }, [OKTA_CLIENT_ID, OKTA_ISSUER]);

  if (!oktaAuth) return <></>;

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

interface Props {
  readonly children: React.ReactNode;
}
